import { Maybe } from 'types/graphqlTypes'
import { DEFAULT_RADIUS } from '../constants'
import { TSavedLaneSchema } from '../schema'

interface IGetSavedLaneSchemaLaneProps {
  pickupCity: Maybe<string>
  pickupStateCode: Maybe<string>
  pickupMiles?: Maybe<number>
  deliveryCity: Maybe<string>
  deliveryStateCode: Maybe<string>
  deliveryMiles?: Maybe<number>
}

/**
 * Returns a SavedLaneSchema lane object from pickup/delivery location and radius
 *
 * @example getSavedLaneSchemaLane({
 *   pickupCity: 'New York',
 *   pickupStateCode: 'NY',
 *   pickupMiles: 25,
 *   deliveryCity: 'Chicago',
 *   deliveryStateCode: 'IL',
 *   deliveryMiles: 50
 * })
 * // { pickup: { id: '', text: 'New York, NY' }, pickupRadius: 25, delivery: { id: '', text: 'Chicago, IL' }, deliveryRadius: 50 }
 */
export const getSavedLaneSchemaLane = ({
  deliveryCity,
  deliveryMiles,
  deliveryStateCode,
  pickupCity,
  pickupMiles,
  pickupStateCode,
}: IGetSavedLaneSchemaLaneProps): TSavedLaneSchema['lane'] => {
  const isValidDropoff = deliveryCity && deliveryStateCode
  return {
    pickup: {
      id: '',
      text: `${pickupCity}, ${pickupStateCode}`,
    },
    pickupRadius: pickupMiles || DEFAULT_RADIUS,
    dropoff: isValidDropoff
      ? {
          id: '',
          text: `${deliveryCity}, ${deliveryStateCode}`,
        }
      : null,
    dropoffRadius: isValidDropoff ? deliveryMiles || DEFAULT_RADIUS : null,
  }
}
